/**
 * Formats a machine metric name for display: title case, no all-caps.
 * Handles metric_id-style values (e.g. "SOME_METRIC" → "Some Metric").
 */
export function formatMetricDisplayName(
  name: string | null | undefined,
): string {
  if (!name || typeof name !== "string") {
    return ""
  }
  const normalized = name.trim()
  if (!normalized) {
    return ""
  }
  // Split on spaces, underscores, hyphens; then title-case each part (fixes ALL CAPS)
  return normalized
    .split(/[\s_-]+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ")
}

export function resolveMetricDisplayName(
  metricDisplayName: string | null | undefined,
  metricName: string | null | undefined,
  fallback = "Unknown Metric",
): string {
  const trimmedDisplayName = metricDisplayName?.trim()
  if (trimmedDisplayName) {
    return trimmedDisplayName
  }

  return formatMetricDisplayName(metricName || fallback)
}
